/* Local dependencies */
import {
  AddColumnToSidebar,
  AddColumnToTable,
  Column,
  CreateConsigneeGoodSpecificationInput,
  CreateConsigneeGoodsSpecError,
  CreateConsigneeGoodsSpecificationActionTypes,
  CreateConsigneeGoodsSpecificationValue,
  CreateConsigneeGoodsSpecRequest,
  CreateConsigneeGoodsSpecResetError,
  CreateConsigneeGoodsSpecSuccess,
  SetCreateConsigneeGoodField,
} from './types';

export function setCreateConsigneeGoodField(
  field: string,
  value: CreateConsigneeGoodsSpecificationValue,
  childField?: string ,
): SetCreateConsigneeGoodField {
  return {
    type: CreateConsigneeGoodsSpecificationActionTypes.SET_CREATE_CONSIGNEE_GOOD_FIELD,
    field,
    value,
    childField,
  };
}

export function addColumnToTable(column: Column): AddColumnToTable {
  return {
    type: CreateConsigneeGoodsSpecificationActionTypes.ADD_COLUMN_TO_TABLE,
    column,
  };
}

export function addColumnToSidebar(column: Column): AddColumnToSidebar {
  return {
    type: CreateConsigneeGoodsSpecificationActionTypes.ADD_COLUMN_TO_SIDEBAR,
    column,
  };
}

export function createConsigneeGoodsSpecRequest(
  input: CreateConsigneeGoodSpecificationInput,
): CreateConsigneeGoodsSpecRequest {
  return {
    type: CreateConsigneeGoodsSpecificationActionTypes.CREATE_CONSIGNEE_GOODS_SPEC_REQUEST,
    input,
  };
}

export function createConsigneeGoodsSpecSucceeded(
  payload: object,
): CreateConsigneeGoodsSpecSuccess {
  return {
    type: CreateConsigneeGoodsSpecificationActionTypes.CREATE_CONSIGNEE_GOODS_SPEC_SUCCESS,
    payload,
  };
}

export function createConsigneeGoodsSpecError(
  error: Error,
): CreateConsigneeGoodsSpecError {
  return {
    type: CreateConsigneeGoodsSpecificationActionTypes.CREATE_CONSIGNEE_GOODS_SPEC_ERROR,
    error,
  };
}

export function resetCreateConsigneeGoodsSpec(): CreateConsigneeGoodsSpecResetError {
  return {
    type: CreateConsigneeGoodsSpecificationActionTypes.CREATE_CONSIGNEE_GOODS_SPEC_RESET,
  };
}
